class DynamicGrid extends HTMLElement {
  connectedCallback() {
    this.handleSectionVisibilityIfNoMediaContent();
  }

  handleSectionVisibilityIfNoMediaContent() {
    // The section is hidden even though it has text content. If no media content is present such as images or videos then the section is hidden'
    const mediaElements = this.querySelectorAll('figure video-media, figure img');
    if (mediaElements.length > 0) this.classList.remove('hidden');
  }
}

if (!customElements.get('dynamic-grid-section')) {
  customElements.define('dynamic-grid-section', DynamicGrid);
}